var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "日志详情",
        visible: _vm.dialogVisible,
        width: "640px",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "detail-wrap",
        },
        [
          _vm.detail.id
            ? [
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("操作摘要"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("操作类型："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "detail-value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getOpTypeTag(_vm.logInfo.opType),
                                size: "small",
                              },
                            },
                            [_vm._v(_vm._s(_vm.logInfo.opTypeName || "-"))]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("操作人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.logInfo.operator || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("操作时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(_vm.logInfo.createTime))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("快照类型："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "detail-value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.side === "before" ? "danger" : "success",
                                size: "mini",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.side === "before"
                                      ? "改前快照"
                                      : "改后快照"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.logInfo.remark
                      ? _c("div", { staticClass: "detail-row" }, [
                          _c("span", { staticClass: "detail-label" }, [
                            _vm._v("备注："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "detail-value" }, [
                            _vm._v(_vm._s(_vm.logInfo.remark)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("基础信息"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("营销方："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.getMarketerName(_vm.detail.marketer))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动状态："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.getStatusName(_vm.detail.status))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.detail.status === 2
                      ? _c("div", { staticClass: "detail-row" }, [
                          _c("span", { staticClass: "detail-label" }, [
                            _vm._v("活动开始时间："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "detail-value" }, [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(_vm.detail.startTime)) +
                                " 至 " +
                                _vm._s(_vm.formatDateTime(_vm.detail.endTime))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动名称："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.detail.activityName || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动编码："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.activityCode ||
                              _vm.detail.activityNo ||
                              _vm.detail.id ||
                              "-"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("适用小程序："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.getCustomerName(_vm.detail.customerId))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动描述："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.detail.description || "-")),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("活动优惠规则"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动场景："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getActivitySceneName(_vm.detail.activityScene)
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("核销供应商："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.getSupplierName(_vm.detail.supplierId))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("参与门店："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.getStoreNames(_vm.detail.storeIds))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动类型："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getActivityTypeName(_vm.detail.activityType)
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("活动门槛："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.threshold !== null &&
                              _vm.detail.threshold !== undefined
                              ? _vm.detail.threshold
                              : "0"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("门槛计算方式："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getThresholdCalcTypeName(
                              _vm.detail.thresholdCalcType
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("优惠计算方式："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getDiscountCalcTypeName(
                              _vm.detail.discountCalcType
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("优惠信息："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "detail-value" },
                        [
                          _vm.paymentList.length
                            ? _c(
                                "el-table",
                                {
                                  staticClass: "payment-table",
                                  attrs: {
                                    data: _vm.paymentList,
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "paymentName",
                                      label: "支付方式",
                                      align: "center",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "优惠力度",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t打 " +
                                                  _vm._s(
                                                    _vm.formatDiscountValue(
                                                      scope.row.discountValue
                                                    )
                                                  ) +
                                                  " 折\n\t\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      886045340
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _c("span", [_vm._v("-")]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("优惠券叠加规则"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("优惠券叠加："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.couponIdsText || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("叠加计算规则："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getStackCalcTypeName(_vm.detail.stackCalcType)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("订单退款优惠计算规则"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("部分退款处理方案："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.getRefundTypeName(_vm.detail.refundType))
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "section-title" }, [_vm._v("备份")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("备注："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.detail.remark || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("创建人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.detail.createBy || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("创建时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(_vm.detail.createTime))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("更新人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(_vm._s(_vm.detail.updateBy || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-row" }, [
                      _c("span", { staticClass: "detail-label" }, [
                        _vm._v("更新时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "detail-value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(_vm.detail.updateTime))
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            : _c("el-empty", {
                attrs: { description: "暂无数据", "image-size": 80 },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }